import { memo, useEffect, useState } from 'react';
import { View, Text } from 'react-native';

import { NavBar, Navigation } from '../components';

import { useDispatch, useSelector } from 'react-redux';
import { getCurrentEmployer, getAssociatedEmployer } from '../../selectors/employers';
import { EMPLOYER_TYPE_AIRFORCE, EMPLOYER_TYPE_MED_RECRUITER } from '../../constants/employerTypes';

import { getEmployerById } from '../employer/actions';

import { HOME_TAB } from '../../constants/tabs';

import MilHomeStaff from './home_mil_staff';
import MilHomePatient from './home_mil_patient';
import MedRecruiterHomeStaff from './home_medrecruiter_staff';
import MedRecruiterHomeProvider from './home_medrecruiter_provider';
import ConsumerHome from './home_consumer';

import TopBarSetup from '../../navbar_maintab_setup';

const HomeScreen = memo((props) => {
  const dispatch = useDispatch();
  const [screenVisible, setScreenVisible] = useState(false);

  useEffect(
    NavBar.setup(props, {
      listeners: {
        componentDidAppear: (id) => {
          Navigation.trackActiveTabNum(HOME_TAB);
          setScreenVisible(true);
        },
        componentDidDisappear: (id) => {
          setScreenVisible(false);
        },
        handleDeepLink: ({ link, payload }) => {
          if (link === HOME_TAB || link === 'home' || link === 'home/main') {
            Navigation.switchToTab(HOME_TAB, props.componentId);
          }
        },
      },
    }),
    []
  );

  const activeScreensForTabs = useSelector((state) => state.screens.nav.activeScreensForTabs);
  const activeTab = useSelector((state) => state.application.currentTabIndex);
  const activeScreen = activeScreensForTabs[activeTab];
  const coldStartFinished = useSelector((state) => state.application.coldStartFinished);
  const employer = useSelector(getCurrentEmployer);
  const associatedEmployer = useSelector(getAssociatedEmployer);

  const isAirforceStaff = employer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isAirforcePatient = associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  const isMedRecruiterStaff = employer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;
  const isMedRecruiterPatient =
    !isMedRecruiterStaff && associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_MED_RECRUITER;
  // const isMedRecruiterStaff = false;
  // const isMedRecruiterPatient = true;

  const screen = props.screen || activeScreen;

  useEffect(() => {
    if ((employer?.employerId || associatedEmployer?.employerId) && coldStartFinished) {
      dispatch(getEmployerById(employer?.employerId || associatedEmployer?.employerId));
    }
  }, [employer?.employerId, associatedEmployer?.employerId, coldStartFinished, dispatch]);

  // maybe change this so we retain state in native when switching tabs
  // if (!screenVisible) return null;

  function renderHome() {
    if (isAirforceStaff) {
      return <MilHomeStaff {...props} screen={screen} screenVisible={screenVisible} />;
    }
    if (isAirforcePatient) {
      return <MilHomePatient {...props} screen={screen} screenVisible={screenVisible} />;
    }
    if (isMedRecruiterStaff) {
      return <MedRecruiterHomeStaff {...props} screen={screen} screenVisible={screenVisible} />;
    }
    if (isMedRecruiterPatient) {
      return <MedRecruiterHomeProvider {...props} screen={screen} screenVisible={screenVisible} />;
    }
    return <ConsumerHome {...props} screen={screen} screenVisible={screenVisible} />;
  }

  return (
    <View style={{ flex: 1 }}>
      <TopBarSetup componentId={props.componentId} />
      {renderHome()}
    </View>
  );
});

HomeScreen.navigatorStyle = NavBar.navigatorStyleRootScreen;

export default HomeScreen;
